import React, { useEffect, useRef } from 'react';
import CBDropdown from '@cb/apricot/CBDropdown';
import { Icon, iconNames } from '@cb/apricot-react-icon';
import { Glyph, glyphNames } from '@cb/apricot-react-glyph';
import { useUID } from 'react-uid';
import cn from 'classnames';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isIcon = (x) => iconNames.includes(x);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isGlyph = (x) => glyphNames.includes(x);
export const Dropdown = ({ dropdownId, dropdownMenuId, selectListLabelId, disabled, caret = true, title = 'Menu List', titleIcon, closeOnClick = false, closeOnClickOutside = true, className, classNameMenu, classNameToggle, iconLeft = false, selectList = false, ariaLabel, callBack, cbRef, children, }) => {
    const uid = useUID();
    // eslint-disable-next-line no-param-reassign
    dropdownId = dropdownId || `apricot_dropdown_${uid}`;
    // eslint-disable-next-line no-param-reassign
    dropdownMenuId = dropdownMenuId || `apricot_dropdown_menu_${uid}`;
    const dropdownSelectedValueId = `apricot_dropdown_select_${uid}`;
    const dropdownRef = useRef(null);
    useEffect(() => {
        const dropdownPlugin = CBDropdown({
            elem: dropdownRef.current,
            closeOnClick,
            closeOnClickOutside,
            selectList,
            callBack,
        });
        if (cbRef) {
            // eslint-disable-next-line no-param-reassign
            cbRef.current = dropdownPlugin;
        }
        return () => {
            if (dropdownPlugin) {
                dropdownPlugin.destroy();
            }
        };
    }, [children]);
    return (React.createElement("div", { className: cn('cb-dropdown', disabled && 'cb-disabled', selectList && 'cb-dropdown-select', className), "data-cbtrack-comp": "apricot-react:dropdown", ref: dropdownRef },
        React.createElement("a", { className: cn('cb-dropdown-toggle', classNameToggle), href: "/#", id: dropdownId, role: "button", "aria-expanded": "false", "aria-haspopup": "true", "aria-controls": dropdownMenuId, "aria-disabled": disabled ? true : undefined, tabIndex: disabled ? -1 : undefined, "aria-labelledby": selectList && selectListLabelId ? `${dropdownSelectedValueId} ${selectListLabelId}` : undefined, "aria-label": ariaLabel },
            titleIcon && isIcon(titleIcon) && React.createElement(Icon, { decorative: true, name: titleIcon }),
            titleIcon && !isIcon(titleIcon) && isGlyph(titleIcon) && React.createElement(Glyph, { decorative: true, name: titleIcon }),
            !selectListLabelId && React.createElement("span", { className: "sr-only" }),
            React.createElement("span", { id: dropdownSelectedValueId }, title),
            caret && (React.createElement(React.Fragment, null,
                React.createElement("i", { className: "cb-icon cb-down", "aria-hidden": "true" }),
                React.createElement("i", { className: "cb-icon cb-up cb-hidden", "aria-hidden": "true" })))),
        React.createElement("div", { className: cn('cb-dropdown-menu', 'cb-box-shadow', classNameMenu) },
            React.createElement("ul", { id: dropdownMenuId, role: "menu", "aria-labelledby": selectList ? dropdownSelectedValueId : dropdownId, className: cn(iconLeft && 'cb-dropdown-left-icon') }, children))));
};
//# sourceMappingURL=Dropdown.js.map